module.exports = __webpack_public_path__ + "img/image.15d19f22.png";